import { z } from 'zod'
import { proposalApi } from './client'

const manufacturerValidationSchema = z.object({
  valid: z.boolean(),
  reason: z.string().nullish(),
})

const manufacturerMatchSchema = z.object({
  matchedManufacturerId: z.string().nullable().default(null),
  reason: z.string().nullish(),
})

const productValidationSchema = z.object({
  valid: z.boolean(),
  reason: z.string().nullish(),
  suggestedType: z.number().nullish(),
})

const productImportSchema = z.object({
  manufacturer: z.string().optional(),
  model: z.string().optional(),
  description: z.string().optional(),
  partNumber: z.string().optional(),
  imageBase64: z.string().optional(),
  imageMediaType: z.string().optional(),
})

export type ManufacturerValidationResult = z.infer<typeof manufacturerValidationSchema>
export type ManufacturerMatchResult = z.infer<typeof manufacturerMatchSchema>
export type ProductValidationResult = z.infer<typeof productValidationSchema>
export type ProductImportResult = z.infer<typeof productImportSchema>

export const validateManufacturer = async (name: string): Promise<ManufacturerValidationResult> => {
  const res = await proposalApi.post('/validate_manufacturer', { name })
  return manufacturerValidationSchema.parse(res.data)
}

export const matchManufacturer = async (params: {
  name: string
  candidates: { id: string; name: string }[]
}): Promise<ManufacturerMatchResult> => {
  const res = await proposalApi.post('/match_manufacturer', params)
  return manufacturerMatchSchema.parse(res.data)
}

export const validateProduct = async (params: {
  manufacturer: string
  model: string
  type: number
}): Promise<ProductValidationResult> => {
  const res = await proposalApi.post('/validate_product', params)
  return productValidationSchema.parse(res.data)
}

export const importProductFromUrl = async (url: string): Promise<ProductImportResult> => {
  const res = await proposalApi.post('/import_product_from_url', { url }, { timeout: 180_000 })
  return productImportSchema.parse(res.data)
}
